<template lang="pug">
modal#create-backup-modal(
  :loading='loading'
  :process-button-label='$t("modal.createBackup.processButtonLabel")'
  :showCancelButton='false'
  :title='$t("modal.createBackup.title")'
  @closed='onCloseModal'
  @process='submit'
  ref='modal'
  size='sm'
)
  ValidationObserver(ref='form' v-slot='{ handleSubmit }')
    form(@submit.prevent='handleSubmit(submit)')
      ValidationProvider(
        :custom-messages='dateMessages'
        name='date_start'
        rules='required'
        v-slot='{ errors }'
        vid='start_date'
      )
        .form-group
          label {{ $t('modal.createBackup.dateStartLabel') }}
        input.form-control(
          :class='{ "border border-danger": errors[0] }'
          type='date'
          v-model='backup.metadata.date_start'
        )
        small.text.text-danger {{ errors[0] }}

      ValidationProvider(
        :custom-messages='dateEndMessages'
        name='date_end'
        rules='required|date_after:@start_date'
        v-slot='{ errors }'
        vid='date_end'
      )
        .form-group
          label {{ $t('modal.createBackup.dateEndLabel') }}
        input.form-control(
          :class='{ "border border-danger": errors[0] }'
          type='date'
          v-model='backup.metadata.date_end'
        )
        small.text.text-danger {{ errors[0] }}

      .form-group.d-flex.align-items-center.gap-2
        input(
          type='checkbox'
          v-model='backup.metadata.include_background_sheet'
        )
        label {{ $t('modal.createBackup.includeBackgroundSheetLabel') }}

      .form-group.d-flex.align-items-center.gap-2
        input(
          type='checkbox'
          v-model='backup.metadata.include_storage_documents'
        )
        label {{ $t('modal.createBackup.includeStorageDocumentsLabel') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import '@/services/Validator';
import Icon from '@/ui/atoms/Icon.vue';
import formHandler from '@/modules/account/common/formHandler';
import BackupService from '@/modules/account/services/http/BackupService';

export default {
  name: 'CreateBackupModal',
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      loading: false,
      backup: {
        request_type: 'backup',
        metadata: {
          workspace: '',
          date_start: '',
          date_end: '',
          include_background_sheet: false,
          include_storage_documents: false,
        },
      },
    };
  },
  computed: {
    dateMessages() {
      return {
        required: this.$t('modal.createBackup.required_date_start'),
      };
    },
    dateEndMessages() {
      return {
        required: this.$t('modal.createBackup.required_date_end'),
        date_after: this.$t('modal.createBackup.date_after'),
      };
    },
  },
  watch: {
    'backup.metadata.date_start'() {
      this.$nextTick(() => {
        this.$refs.form.refs.date_end.validate();
      });
    },
  },
  methods: {
    cleanInputBackup() {
      this.backup = {
        request_type: 'backup',
        metadata: {
          workspace: '',
          date_start: '',
          date_end: '',
          include_background_sheet: false,
          include_storage_documents: false,
        },
      };
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    formatDate(date, endOfDay = false) {
      if (!date) return '';
      const time = endOfDay ? '23:59:59' : '00:00:00';
      return `${date} ${time}`;
    },

    async submit() {
      const isValid = await this.$refs.form.validate();

      if (!isValid) return;

      const payload = {
        request_type: this.backup.request_type,
        metadata: {
          ...this.backup.metadata,
          workspace: this.$store.state.organizations.selected.id,
          date_start: this.formatDate(this.backup.metadata.date_start),
          date_end: this.formatDate(this.backup.metadata.date_end, true),
        },
      };

      formHandler.submit(this, () => BackupService.create(payload), {
        fieldsByPropertyName: {
          date_start: 'date_start',
          date_end: 'date_end',
        },
        successHandler: (response) => {
          formHandler.defaultSuccess(response);
          this.cleanInputBackup();
          this.$refs.modal.close();
          this.$emit('refresh');
        },
      });
    },
    onCloseModal() {
      this.cleanInputBackup();
    },
  },
};
</script>
